export default "__VITE_ASSET__Bkwp0z3G__"